import React, { useState } from 'react'
import pluralize from 'pluralize'
import Select from 'react-select'
import { Drawer, DatePicker, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'

import { AiOutlineDown, AiOutlineDelete } from 'react-icons/ai'

import { useToggle, stringifyDate, usePet, normalize, permissions as parsePermissions, useListData, server } from '../../modules'

import Receive from '../../components/reusable/receive'
import Datepicker from '../../components/reusable/datePicker'

import POItem from '../../components/drawers/poItem'
import NewPO from '../../components/drawers/newPO'
import Confirm from '../../components/reusable/confirm'
import AddItem from '../../components/drawers/addItem'

const { RangePicker } = DatePicker
const { TabPane } = Tabs

let termOptions = [
    'Net 15',
    'Net 30',
    'Net 45',
    'Net 60',
    'Due on Receipt',
    'Due end of the month',
    'Due end of next month',
]

const PurchaseOrder = ({ params, permissions }) => {
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState(null)
    const [index, setIndex] = useState(null)
    const [terms, setTerms] = useState()
    const [tnc, setTnc] = useState()
    const [date, setDate] = useState()
    const [deliveryDate, setDeliveryDate] = useState()
    const [vals, setVals] = useState({})
    const [purchaseOrder, setPO] = useState()

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)
    const [select, toggleSelect] = useToggle()
    const [editModal, toggleEditModal] = useToggle()
    
    const onComplete = ({}, notif, ops) => {
        notif('Purchase order has been deleted', ops('success'))
        refetch()
    }

    const [{ loading: newLoading }, deletePO] = usePet('deletePurchaseOrder', { id }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Deleting Purchase Order...' } })

    const onAComplete = ({}, notif, ops) => {
        notif('Purchase order has been approved', ops('success'))
        refetch()
    }

    const [{ loading: appLoading }, approvePO] = usePet('approvePurchaseOrder', { id }, { notify: true, callback: onAComplete, manual: true, load: { msg: 'Approving Purchase Order...' } })

    const [{ loading, error }, refetch] = usePet('purchaseOrder', { id }, { notify: true, callback: ({ data }) => {

        let keys = ['terms', 'date', 'deliveryDate', 'tnc']

        keys.forEach(key => {
            let val = data.details.find(itm => itm.name === key)
            if (val)
                if (key === 'terms') {
                    setTerms({ label: val?.value, value: val?.value })
                } else if (key === 'tnc') {
                    setTnc(val?.value)
                } else if (key === 'date') {
                    setDate(moment(val?.value))
                } else if (key === 'deliveryDate') {
                    setDeliveryDate(moment(val?.value))
                }
        })

        setPO(data)
    } })

    const selectItems = (val, i) => {
        setSelected(val)
        setIndex(i)
        toggleEditModal()
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }

    const [, editDetails] = usePet('editPurchaseOrderDetails', { 
        id,
        details: {
            ...vals
        }
    }, { notify: true, manual: true, load: { msg: 'Saving changes...' }, callback: ({ data }, notif, ops) => {
        notif('Changes have been saved', ops('success')) 
        setPO(data)
    } })
    
    const editVal = (val, key) => {
        let initial = purchaseOrder.details.find(itm => itm.name === key)
        console.log({ initial, val })
        if (initial?.value !== val) {
            setVals({
                [key]: val
            })
            editDetails()
        }
    }

    const disableDate = (currentDate) => {
        return currentDate && currentDate.isBefore(date, 'day');
      };

      const actions = (action, po) => {
        setSelected(po._id)

        setTimeout(() => {
            if (action === 'delete')
                deletePO()
            else if (action === 'approve')
                approvePO()
        }, 200)
    }  

    return (
      <Drawer
        closable
        maskClosable
        visible={visible}
        onClose={close}
        width="60%"
      >
        <p className="font-extrabold text-3xl mb-0">{purchaseOrder?.code}</p>
        <div className="flex justify-between items-center">
          <span>
            <p className="text-gray-500 text-xs italic mb-0">
              Generated by {purchaseOrder?.generatedBy?.name} for{" "}
              {purchaseOrder?.supplier?.name} on{" "}
              {stringifyDate(purchaseOrder?.date)}
            </p>
            <div className="text-yellow-500 text-xs italic mb-0">
              {purchaseOrder?.approvedBy
                ? `Approved by ${purchaseOrder?.approvedBy?.name}`
                : "Awaiting approval"}
            </div>
          </span>
          <Dropdown
            overlay={
              <Menu>
                {permissions.canAdd && !purchaseOrder?.approvedBy && (
                  <Link to={`/app/procurement/purchase-orders/${id}/newItem`}>
                    <Menu.Item>Add Item to Purchase Order</Menu.Item>
                  </Link>
                )}
                {permissions.canApprove && !purchaseOrder?.approvedBy && (
                  <Menu.Item
                    onClick={() =>
                      Confirm({
                        title: "Approve Purchase Order?",
                        message:
                          "Please confirm before proceeding with this action",
                        okText: "Approve Purchase Order",
                        onOk: approvePO,
                      })
                    }
                  >
                    Approve Purchase Order
                  </Menu.Item>
                )}
                {permissions.canDelete && !purchaseOrder?.approvedBy && (
                  <Menu.Item
                    onClick={() =>
                      Confirm({
                        title: "Delete Purchase Order?",
                        message: "Please note that this action is irreversable",
                        okText: "Delete Purchase Order",
                        onOk: () => actions("delete", purchaseOrder),
                      })
                    }
                  >
                    Delete Purchase Order
                  </Menu.Item>
                )}
                {purchaseOrder?.approvedBy && (
                  <a
                    className="text-gray-600"
                    rel="noreferrer"
                    target="_blank"
                    href={`${server}/purchaseOrder/${purchaseOrder?._id}/print`}
                  >
                    <Menu.Item>Print Purchase Order</Menu.Item>
                  </a>
                )}
              </Menu>
            }
          >
            <button className="btn m-0 hisani-btn-green-light text-white">
              <span className="hidden xs:block mr-2">Actions</span>
              <AiOutlineDown />
            </button>
          </Dropdown>
        </div>
        <Tabs className="mt-0">
          <TabPane key="0" tab="Received Items">
            <table className="table-auto w-full">
              {/* Table header */}
              <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                <tr>
                  <th className="p-2">
                    <div className="font-semibold text-left">No</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Item</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Quantity</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Price</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Disc</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Tax</div>
                  </th>
                  <th className="p-2">
                    <div className="font-semibold text-left">Total</div>
                  </th>
                  {!purchaseOrder?.approvedBy && <th className="p-2" />}
                </tr>
              </thead>
              <tbody className="text-sm font-medium divide-y divide-gray-100">
                {purchaseOrder?.items?.map((item, key) => (
                  <tr>
                    <td className="p-2">
                      <div className="text-center">
                        {select ? (
                          <input
                            onChange={() => choose(item._id)}
                            checked={chosen.includes(item._id)}
                            type="checkbox"
                            className="form-checkbox cursor-pointer h-5 w-5"
                          />
                        ) : (
                          `${key + 1}.`
                        )}
                      </div>
                    </td>
                    <td className="p-2">
                      <div className="text-left">{item?.itemName}</div>
                    </td>
                    <td className="p-2 text-left">
                      <div className="text-left">
                        {Math.abs(item.quantity)}{" "}
                        {pluralize(item.unit, item.quantity)}{" "}
                      </div>
                    </td>
                    <td className="p-2">
                      <div className="text-left">Ksh. {item?.unitPrice}</div>
                    </td>
                    <td className="p-2 text-left">
                      <div className="text-left">
                        Ksh. {normalize(item?.discount)}
                      </div>
                    </td>
                    <td className="p-2 text-left">
                      <div className="text-left">{item?.vat}%</div>
                    </td>
                    <td className="p-2 text-left">
                      <div className="text-left">
                        Ksh.{" "}
                        {normalize(
                          Math.abs(item.quantity) *
                            (item.unitPrice - item.discount)
                        )}
                      </div>
                    </td>
                    {!purchaseOrder?.committed && permissions.canEdit && (
                      <td className="p-2">
                        <button
                          onClick={() => selectItems(item, key)}
                          className="btn hisani-btn-green-light text-white"
                        >
                          <span className="hidden xs:block mr-2">Edit</span>
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="flex flex-col items-end pr-3 py-3">
              <p className="font-semibold text-lg underline mb-2">Overview</p>
              <p className="mb-1">
                Discount: Ksh.{" "}
                {normalize(
                  purchaseOrder?.items?.reduce(
                    (total, item) => total + item.quantity * item.discount,
                    0
                  )
                )}
              </p>
              <p className="mb-1">
                VAT: Ksh.{" "}
                {normalize(
                  purchaseOrder?.items?.reduce(
                    (total, item) =>
                      total +
                      item.quantity *
                        (item.unitPrice - item.discount) *
                        (item.vat / 100),
                    0
                  )
                )}
              </p>
              <p className="mb-1">
                Total: Ksh.{" "}
                {normalize(
                  purchaseOrder?.items?.reduce(
                    (total, item) =>
                      total +
                      (item?.unitPrice - item?.discount) * item?.quantity +
                      (item?.unitPrice - item?.discount) *
                        item?.quantity *
                        (item?.vat / 100),
                    0
                  )
                )}
              </p>
            </div>
          </TabPane>
          <TabPane tab="Additional Details" key="2">
            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-3">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-email"
                >
                  Payment Terms
                </label>
                <Select
                  className="min-w-56 mr-4"
                  value={terms}
                  onChange={(t) => {
                    setTerms(t);
                    editVal(t?.value, "terms");
                  }}
                  options={termOptions.map((term) => ({
                    label: term,
                    value: term,
                  }))}
                  placeholder="Select Payment Terms"
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-username"
                >
                  Purchase Order Date
                </label>
                <Datepicker
                  value={date}
                  disabledDate={disableDate}
                  onChange={(d) => {
                    setDate(d);
                    editVal(d?._d, "date");
                  }}
                  placeholder="Purchase Order Date"
                />
              </div>
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-email"
                >
                  Expected Delivery Date
                </label>
                <Datepicker
                  value={deliveryDate}
                  disabledDate={disableDate}
                  onChange={(d) => {
                    setDeliveryDate(d);
                    editVal(d, "deliveryDate");
                  }}
                  placeholder="Expected Delivery Date"
                />
              </div>
            </div>
            <div className="flex flex-wrap -mx-3">
              <div className="w-full px-3 mb-6 md:mb-0">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-username"
                >
                  Terms & Conditions
                </label>
                <textarea
                  value={tnc}
                  onBlur={(e) => editVal(e.target.value, "tnc")}
                  onChange={(e) => setTnc(e.target.value)}
                  rows="5"
                  name="terms"
                  className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="grid-username"
                  type="text"
                  placeholder="Terms & Conditions"
                />
              </div>
            </div>
          </TabPane>
        </Tabs>
        <Switch>
          <Route path="/app/procurement/purchaseOrders/:id/new">
            <POItem />
          </Route>
          <Route path="/app/procurement/purchaseOrders/:id/:index">
            <POItem />
          </Route>
          <Route path="/app/procurement/purchase-orders/:id/newItem">
            <AddItem
              path={`/app/procurement/purchase-orders/${id}`}
              onClose={refetch}
            />
          </Route>
        </Switch>
      </Drawer>
    );
}

const PurchaseOrders = () => {
    const [ranges, setRanges] = useState()
    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [token, setToken] = useState()
    
    const { params, user } = useSelector(state => state.application)

    const history = useHistory()

    const [visible, toggleVisible] = useToggle(true)
    const [committed, toggleCommitted] = useToggle()

    const { id } = useParams()

    const [
        { loading: invLoading, error: invError, fetch },
        { list: purchaseOrders },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('purchaseOrders', ranges ?
        { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null, committed }
        : { string, committed }
        , { notify: true, manual: false })
        
    const refetch = () => {
        fetch()
        navigate(1)
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }

    let permissions = {
        canGenerate: parsePermissions(user, 'Procurement', 'generate-purchase-order'),
        canEdit: parsePermissions(user, 'Procurement', 'edit-purchase-order'),
        canAdd: parsePermissions(user, 'Procurement', 'add-item-to-purchase-order'),
        canApprove: parsePermissions(user, 'Procurement', 'approve-purchase-order'),
        canDelete: parsePermissions(user, 'Procurement', 'delete-purchase-order')
    }

    const onComplete = ({}, notif, ops) => {
        notif('Purchase order has been deleted', ops('success'))
        refetch()
    }

    const [{ loading: newLoading }, deletePO] = usePet('deletePurchaseOrder', { id: selected }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Deleting Purchase Order...' } })

    const onAComplete = ({}, notif, ops) => {
        notif('Purchase order has been approved', ops('success'))
        refetch()
    }

    const [{ loading: appLoading }, approvePO] = usePet('approvePurchaseOrder', { id: selected }, { notify: true, callback: onAComplete, manual: true, load: { msg: 'Approving Purchase Order...' } })

    const actions = (action, po) => {
        setSelected(po._id)

        setTimeout(() => {
            if (action === 'delete')
                deletePO()
            else if (action === 'approve')
                approvePO()
        }, 200)
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="flex justify-between items-center mt-1 mb-5">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Purchase Orders Using Code" />
                <span className="flex items-center">
                    <RangePicker />
                    {
                        permissions.canGenerate &&
                        <Link to="/app/procurement/purchase-orders/new">
                            <button className="btn ml-2 py-2.5 hisani-btn-green-light text-white">New Purchase Order</button>
                        </Link>
                    }
                </span>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Purchase Orders</h2>
                </header>
                <Receive
                    error={invError}
                    loading={invLoading}
                    progress>
                    {
                        purchaseOrders.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">No</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Code</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Supplier</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Status</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Created By</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Date</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        purchaseOrders.map((purchaseOrder, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{purchaseOrder?.code}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{purchaseOrder?.supplier?.name}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{purchaseOrder?.approvedBy ? 'Approved' : 'Awaiting Approval'}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{purchaseOrder?.generatedBy?.name}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{stringifyDate(purchaseOrder.date)}</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Dropdown
                                                        overlay={
                                                            <Menu>
                                                                <Link to={`/app/procurement/purchase-orders/${purchaseOrder._id}`}>
                                                                    <Menu.Item>View</Menu.Item>
                                                                </Link>
                                                                {   
                                                                    purchaseOrder?.approvedBy ? 
                                                                        <a className="text-gray-600" rel="noreferrer" target="_blank" href={`${server}/purchaseOrder/${purchaseOrder?._id}/print`}>
                                                                            <Menu.Item>Print Purchase Order</Menu.Item>
                                                                        </a>
                                                                    : <>
                                                                        <Menu.Item onClick={ () => Confirm({
                                                                            title: 'Approve Purchase Order?',
                                                                            message: 'Please confirm before proceeding with this action',
                                                                            okText: 'Approve Purchase Order',
                                                                            onOk: () => actions('approve', purchaseOrder)
                                                                        }) }>Approve Purchase Order</Menu.Item>
                                                                        <Menu.Item onClick={ () => Confirm({
                                                                            title: 'Delete Purchase Order?',
                                                                            message: 'Please note that this action is irreversable',
                                                                            okText: 'Delete Purchase Order',
                                                                            onOk: () => actions('delete', purchaseOrder)
                                                                        }) }>Delete Purchase Order</Menu.Item>
                                                                    </>
                                                                }
                                                            </Menu>
                                                        }>
                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                    </Dropdown>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please click above to add a new purchase order</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
            <Switch>
                <Route path="/app/procurement/purchase-orders/new">
                    <NewPO path="/app/procurement/purchase-orders" onClose={ refetch } />
                </Route>
                <Route path="/app/procurement/purchase-orders/:id">
                    <PurchaseOrder params={ params } user={ user } permissions={ permissions } />
                </Route>
            </Switch>
        </div>
    )
}

export default PurchaseOrders